<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-original-size`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.2 6h39.6c1.215 0 2.2.948 2.2 2.118v31.764c0 1.17-.985 2.118-2.2 2.118H4.2C2.985 42 2 41.052 2 39.882V8.118C2 6.948 2.985 6 4.2 6zM6 10v28h36V10H6zm16 16h4v4h-4v-4zm-6-10a1 1 0 011 1v14a1 1 0 01-1 1h-2.02a1 1 0 01-1-1V19.922l-2.232 1.272A.5.5 0 0110 20.76v-2.496a1 1 0 01.509-.87l2.243-1.265a1 1 0 01.491-.129H16zm20 0a1 1 0 011 1v14a1 1 0 01-1 1h-2.02a1 1 0 01-1-1V19.922l-2.232 1.272A.5.5 0 0130 20.76v-2.496a1 1 0 01.509-.87l2.243-1.265a1 1 0 01.491-.129H36zm-10 2v4h-4v-4h4z"/></svg>
</template>
<script>

export default {
  name: 'IconOriginalSize',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
